const getVariationCombos = (parameters) => {
  if (!Array.isArray(parameters) || parameters.length === 0) return [];

  const withValues = parameters.filter(
    (p) => Array.isArray(p.values) && p.values.length > 0,
  );

  if (withValues.length === 0) return [];

  const cartesian = (arrs) =>
    arrs.reduce((a, b) => a.flatMap((d) => b.map((e) => [...d, e])), [[]]);

  const partialCombos = cartesian(withValues.map((p) => p.values));

  // Re-expand to full parameter list, inserting null for empty-value params
  const combos = partialCombos.map((partial) => {
    let partialIdx = 0;
    return parameters.map((p) => {
      if (Array.isArray(p.values) && p.values.length > 0) {
        return partial[partialIdx++];
      }
      return null;
    });
  });

  return combos;
};

export default getVariationCombos;
